import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { logOut, updateLocalStorageToken } from '../../../../../../containers/resources/utils';

export const findRatesForSpaceSlice = createSlice({
  name: 'findRatesForSpace',
  initialState: {
    rates: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  },
  reducers: {
    initialStateFindRatesForSpace(state, action) {
      return {
        rates: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    requesFindRatesForSpace(state, action) {
      return {
        rates: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      }
    },
    fetchFindRatesForSpaceSuccess(state, action) {
      return {
        rates: action.payload,
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    fetchFindRatesForSpaceError(state, action) {
      return {
        rates: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.payload,
      }
    }
  }
})

export const findRatesForSpace = (reservation_id, booking_id, query) => dispatch => {
  dispatch(requesFindRatesForSpace());
  axios.get(`reservation/${reservation_id}/booking/${booking_id}/findRates${query}`)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(fetchFindRatesForSpaceSuccess(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(findRatesForSpace(reservation_id, booking_id, query));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchFindRatesForSpaceError(json.data.data));
      }
    })
};

export const {
  initialStateFindRatesForSpace,
  requesFindRatesForSpace,
  fetchFindRatesForSpaceSuccess,
  fetchFindRatesForSpaceError,
} = findRatesForSpaceSlice.actions;

export default findRatesForSpaceSlice.reducer;